module.exports = __webpack_public_path__ + "assets/img/card_slot.30bb1730.png";